const POSTAL_CODE_REGEX = /^\d{5}(-\d{4})?$/;

// matches various English & Spanish synonyms for PO boxes; does not match mid-word keywords e.g. "Robinhood St"
const PO_BOX_REGEX =
  /^(.*[^a-zÀ-ÖØ-öø-ÿ])?(p(\s|\.)*o(\s|\.)*box(\s|\.)*|gpo\s*box|lock\s*box|call\s*box|box|bin|(firm)?\s*caller|drawer|apartado|aptdo|buzon)([^a-zÀ-ÖØ-öø-ÿ].*)?$/i;

// Currently only used to detect if emojis are present;
// would need to modify it if we're doing something more complicated
const EMOJI_REGEX = /\p{Emoji}/gu;

export { PO_BOX_REGEX, POSTAL_CODE_REGEX, EMOJI_REGEX };
